<template>
	<section class=" content  ">
		<div class="container-fluid" >
			<div class="row">
				<div class="col-12" v-if="$gate.isAdmin()">
					<div class="card">
						<div class="card-header">
							<h3 class="card-title"> Заказы </h3><br>
							<div class="card-tools">
								<button type="button" class="btn btn-sm btn-success" @click="$refs.modal.openModal()">
									<i class="fa fa-print"></i>
									Печать за период
								</button>
								<button type="button" class="btn btn-sm btn-success" @click="$router.push({name: 'printToday', params: { print: 2}})">
									<i class="fa fa-print"></i>
									Печать за сегодня
								</button>
								<router-link to="/addzakaz">
									<button type="button" class="btn btn-sm btn-primary" @click="newModal">
										<i class="fa fa-plus-square"></i>
										Создать заказ
									</button>
								</router-link>
							</div>
						</div>

						<!-- /.card-header -->
						<div class="card-body table-responsive p-0">
							<div id="dynamic-component-demo" class="demo" :value="i=0">
								<button
												v-for="tab in tabs"
												v-bind:key="tab.name"
												v-bind:class="['tab-button', { active: currentTab.name === tab.name }]"
												v-on:click="currentTab = tab">
									{{ tab.name }}
									{{ zakazs[i++] }}
								</button>
								<component v-bind:is="currentTab.component" class="tab"></component>
							</div>
						</div>
						<!-- /.card-body -->
					</div>
					<!-- /.card -->
				</div>

				<div v-if="!$gate.isAdmin()">
					<not-found></not-found>
				</div>
			</div>

			<!-- Modal -->
			<center-modal-widget
							:id="'modal'"
							:title="'Печать за период'"
							:is_close="true"
							ref="modal"
			>
				<div class="container center-modal_win">
					<div class="row">

						<div class="col-md-3">
							<label>Дата доставки:</label> <br>
							<input type="date" v-model="search.date" class="form-control" >
						</div>

						<div class="col-md-3">
							<label>Время c:</label> <br>
							<input type="time" v-model="search.timestart" class="form-control">
						</div>
						<div class="col-md-3">
							<label>Время по:</label> <br>
							<input type="time" v-model="search.timeend" class="form-control">
						</div>
					</div>
				</div>
				<div class="button_modal">
					<button type="button" class="btn btn-sm btn-success" @click="printData">
						<i class="fa fa-print"></i>
						Печать за период
					</button>
				</div>
			</center-modal-widget>
		</div>


	</section>
</template>
<style>
.center-modal_win {
	text-align: center;
	position: relative;
	padding-bottom: 50px;
	font-size: large;
}
.center-modal_win .form-control{
	font-size: large;
}

.button_modal {
	position: absolute;
	bottom: 2em;
	left: 40%;
}

.table-responsive {
	overflow: hidden;
}

.tab-button {
	padding: 6px 10px;
	border-top-left-radius: 3px;
	border-top-right-radius: 3px;
	border: 1px solid #ccc;
	cursor: pointer;
	background: #f0f0f0;
	margin-bottom: -1px;
	margin-right: -1px;
}

.tab-button:hover {
	background: #e0e0e0;
}

.tab-button.active {
	background: #a9c4db;
	border: 1px solid #ccc;
	/*padding: 10px;*/
}

.tab {
	/*border: 1px solid #ccc;*/
	/*padding: 10px;*/
}

a {
	color: black;
}


</style>
<script>
const NotFound = {template: '<p>Страница не найдена</p>'}

var tabs = [
	{
		name     : "Заказы за все время  ",
		component: {
			template: "<ZakazAll></ZakazAll>"
		}
	},
	{
		name     : "Заказы на сегодня",
		component: {
			template: "<ZakazToday></ZakazToday>"
		}
	},
	{
		name     : "Заказы на завтра",
		component: {
			template: "<ZakazFuture></ZakazFuture>"
		}
	},
	{
		name     : "Заказы от клиентов",
		component: {
			template: "<ZakazClient></ZakazClient>"
		}
	},
	{
		name     : "Корзина",
		component: {
			template: "<ZakazTrash></ZakazTrash>"
		}
	}
];

export default {
	data() {
		return {
			zakazs    : [],
			tabs      : tabs,
			currentTab: tabs[0],
			search    : {
				'date'     : new Date().toISOString().slice(0, 10),
				'timestart': '',
				'timeend'  : '',
			},
		}
	},
	methods: {
		 convertTimeFormat(timeString) {
			const convertedTime = timeString.replace(':', '-');
			return convertedTime;
		},
		printData() {
			if (this.search.timestart != '' && this.search.timeend != '') {
				if (this.search.timestart <= this.search.timeend) {
				} else {
					Toast.fire({
						icon : 'error',
						title: 'Не корректно заполнено время, время с не может быть больше времени по'
					});
					return;
				}
			}
			if (this.search.date == '') {
				this.search.date = new Date().toISOString().slice(0, 10);
			}

			this.$refs.modal.closeModal();
			var data=this.search.date+'n'+this.convertTimeFormat(this.search.timestart)+'n'+this.convertTimeFormat(this.search.timeend);
			this.$router.push({name: 'printToday', params: {print:data}});
		},

		newModal() {
		},
		loadCatalogs() {
			// if(this.$gate.isAdmin()){
			axios.get("api/zakaz").then(({data}) => (this.zakazs = data.data));
			// }
		},
	},
	getResults(page = 1) {
		this.$Progress.start();
		axios.get('api/zakaz?page=' + page).then(({data}) => (this.zakazs = data.data));
		this.$Progress.finish();
	},
	created() {
		this.$Progress.start();
		this.loadCatalogs();
		this.$Progress.finish();
	},


}
</script>
